import React from "react";
import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../api";

export function DashboardPage() {
  const { data, isLoading } = useQuery({
    queryKey: ["admin", "users"],
    queryFn: () => apiFetch<{ users: unknown[] }>("/api/admin/users"),
  });

  const userCount = data?.users?.length ?? 0;

  return (
    <div className="admin-page">
      <header className="admin-page-header">
        <h1>Dashboard</h1>
      </header>
      <div className="admin-page-content">
        <div className="admin-stats">
          <div className="admin-stat-card">
            <span className="material-symbols-outlined admin-stat-icon">group</span>
            <div>
              <div className="admin-stat-value">{isLoading ? "—" : userCount}</div>
              <div className="admin-stat-label">Users</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
